<template>
  <div>
    <sFormItem
      v-if="additionalProps"
      prop="field"
      :rules="rules.field">
      <sSelect
        class="width-100 mt-1"
        clearable
        data-qa="additional-field-list"
        :disabled="disabled"
        filterable
        :placeholder="$t('Common.Select')"
        :value="valueMutable.field"
        @update:value="sendValue('field', $event)">
        <sOption
          v-for="additionalProp in additionalProps"
          :key="`tender-contact-${additionalProp.id}`"
          :data-qa="`additional-field-item-${additionalProp.id}`"
          :disabled="disabled"
          :label="additionalProp.caption"
          :value="additionalProp.id">
          <div>
            <div>{{ additionalProp.caption }}</div>
            <sChip
              v-if="additionalProp.typeId"
              class="font-size-12 opacity-8">
              {{ additionalProp.typeId }}
            </sChip>
            <sChip
              v-if="additionalProp.bindingLevel"
              class="font-size-12 opacity-8 ml-1">
              {{ additionalProp.bindingLevel === 'LOT' ? $t('Tenders.ToLot') : $t('Tenders.ToTender') }}
            </sChip>
          </div>
        </sOption>
      </sSelect>
    </sFormItem>
    <AdditionalFieldInput
      v-if="additionalField"
      :field="additionalField"
      :label="false"
      :loading="disabled"
      :rules="rules.parameters"
      validation-prop="parameter"
      @update:field="sendValue('parameters', $event.value)"/>
  </div>
</template>
<script>
import automations from 'mixins/automations.js'
import AdditionalFieldInput from 'components/additional fields/AdditionalFieldInput.vue'

export default {
  name: 'updateField',
  mixins: [ automations ],
  data() {
    const that = this
    return {
      rules: {
        field: {
          required: true,
          trigger: 'change',
          validator(rule, value, callback) {
            if (!that.valueMutable?.field) {
              callback(new Error(that.$t('Validate.Required')))
            }
            callback()
          },
        },
        parameters: {
          required: true,
          trigger: 'change',
          validator(rule, value, callback) {
            if (!that.valueMutable?.parameters) {
              callback(new Error(that.$t('Validate.Required')))
            }
            callback()
          },
        },
      }
    }
  },
  methods: {
    sendValue(field, props) {
      const result = this.$_.cloneDeep(this.value)
      const parameters = this.$_.cloneDeep(this.valueMutable)

      parameters[field] = props
      if (field === 'field') {
        parameters.parameters = null


        this.parametersRules = this.$_getAdditionalFieldRule(
          this.additionalProps.typeId,
          this
        )
      }
      result.parameters = JSON.stringify(parameters)

      this.$emit('update:value', result)
    }

  },
  computed: {
    additionalField() {
      if (!this.valueMutable?.field) {
        return null
      }
      const result = this.$_.cloneDeep(this.additionalProps.find(i => i.id === this.valueMutable.field))
      result.value = this.valueMutable.parameters
      return result
    },
    valueMutable: {
      get() {
        if (!this.value?.parameters) {
          return {}
        }
        try {
          return JSON.parse(this.value.parameters) || {}
        } catch {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            message: this.$t('Automation.ErrorActionParams'),
            showClose: true,
            progress: true,
          })
          return {}
        }
      },
    },
  },
  components: {
    AdditionalFieldInput
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    additionalProps: {
      type: [Object, Array]
    },
  },
}
</script>
